import type { IconProps } from "@/components/Icons/index";

/** From `public/assets/images/figma/sidebar-chevron.svg` — `viewBox="0 0 10.357 6.01184"`. */
export const SidebarChevronIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 10.357 6.01184" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.17851 1.17851L5.17851 5.17851L9.17851 1.17851"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
